import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  Card,
  CardContent,
  Typography,
  FormHelperText,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Autocomplete,
  Alert,Menu, ListItemIcon, ListItemText,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles, style } from "@mui/system";
import { useAuth } from "../../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useLocation } from "react-router-dom";


function AdmissionExpensesReports() {
  const [searchQuery, setSearchQuery] = useState("");

  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const [selectedBus, setSelectedBus] = useState("");
  const [selectedBusType, setSelectedBusType] = useState("");



  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  
   const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
  const { userId, oId,role,pId,userRoleName } = useAuth();

  const UserId = userId || selectedUsers;

  const { state } = useLocation();
  const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;
  const [loadinga, setLoadinga] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [loadingc, setLoadingc] = useState(false);

  const [loadingb, setLoadingb] = useState(true);
  const [error, setError] = useState(null);
  const [expenseData, setExpenseData] = useState([]);

  const [selectedRowData, setSelectedRowData] = useState(null);

  const [routeLoading, setRouteLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [busLoading, setBusLoading] = useState(false);

  const [busType, setBusType] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState({});

  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rows, setRows] = useState([]);
  const [selectedTypea, setSelectedTypea] = useState("");

  const [data, setData] = useState([]); // Store API data

  const [loading, setLoading] = useState(true); // Loading state

  const [busExpenses, setBusExpenses] = useState([]); // Renamed from "data"
  const [selectedExpense, setSelectedExpense] = useState(null); // Renamed from "editData"
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false); // Renamed from "open"

  // State for custom date picker
  const [openCustomDialog, setOpenCustomDialog] = useState(false);
  
  
  const [filteredData, setFilteredData] = useState([]); // Stores filtered data
  const [typeOptions, setTypeOptions] = useState([]); // Store fetched types
  const [selectedType, setSelectedType] = useState(""); // Store selected filter


  const [expensesType, setExpensesType] = useState([]);
  const [selectedexpenseType, setSelectedexpenseType] = useState("");
  const [selectedDate, setSelectedDate] = useState("currentMonth");

  const [uniqueExpensesType, setUniqueExpensesType] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");




  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  // const handleClose = () => {
  //   setExportAnchorEl(null);
  // };







  // useEffect(() => {
  //   fetchData();
  // }, []);

  // // Fetch data from API
  // const fetchData = async () => {
  //   try {
  //     const response = await fetch(`${baseUrl}/api/AllExpenses/getAll/${userId}/${oId}`);
  //     const data = await response.json();
  //     console.log("API Response:", data);

  //     const reversedData = data.reverse(); // Store full API data in reverse order

  //     setExpenseData(reversedData); // Store full API data
  //     applyDateFilter("currentMonth", null, null, reversedData); // Apply the current month filter by default
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


    // Handle date filter change
    // const handleDateChange = (event) => {
    //   const dateFilter = event.target.value;
    //   setSelectedDate(dateFilter);
  
    //   if (dateFilter === "custom") {
    //     setOpenCustomDialog(true); // Open custom date selection dialog
    //   } else {
        
    //   }
    // };


    // Handle date filter change
const handleDateChange = (event) => {
  const selectedValue = event.target.value;
  setSelectedDate(selectedValue);
  ///dateFilter===selectedValue
  if (selectedValue === "customDate") {
    setOpenCustomDialog(true); // Open custom date selection dialog
  }
};



const handleGetButtonClick = () => {
  if (startDate && endDate) {
    console.log("Fetching data for:", startDate, endDate);
    setSelectedDate("customDate"); // This updates UI but doesn't fetch data
    fetchExpensesData(); // Manually fetch data only when clicking "Get"
    setOpenCustomDialog(false);
  } else {
    console.error("Start Date or End Date is missing");
  }
};

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${PrincipalId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

useEffect(() => {
  if (role === "PRINCIPAL" || role === "TRANSPORT" || role === "ORGANIZATION") {
    fetchUsers();
  }
}, [role]); 




// Fetch all expenses list based on date range
const fetchExpensesData = async () => {
if(!UserId) return;
  setLoading(true);
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (selectedDate) {  // ✅ Corrected to use 'selectedDate'
      case "today":
        endpoint = `${baseUrl}/api/AllExpenses/todayExpenses/ADMISSION_FEE/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/AllExpenses/yesterdayExpenses/ADMISSION_FEE/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/AllExpenses/lastWeekExpenses/ADMISSION_FEE/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "currentMonth":
        endpoint = `${baseUrl}/api/AllExpenses/thisMonthExpenses/ADMISSION_FEE/${UserId}/${oId}?date=${formattedDate}`;
        break;

      case "customDate":
          if (startDate && endDate) {
            endpoint = `${baseUrl}/api/AllExpenses/customDateExpenses/ADMISSION_FEE/${UserId}/${oId}?startDate=${startDate}&endDate=${endDate}`;
          } else {
            console.error("Custom date range is missing start or end date");
            return;
          }
          break;

      default:
        endpoint = `${baseUrl}/api/AllExpenses/getAll/${UserId}/${oId}`;
        break;
    }


    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    setExpenseData(data.reverse()); // Reverse order for latest data on top

     // Extract unique expense types
     const expenseTypesSet = new Set(data.map((item) => item.expensesType));
     setUniqueExpensesType([...expenseTypesSet]); // ✅ Set unique types to dropdown

  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchExpensesData();
}, [selectedDate,UserId]);



const [filteredExpensesData, setFilteredExpensesData] = useState([]); // Filtered data for display
// Fetch data when expense type changes
useEffect(() => {
  let filteredData = expenseData;

  if (selectedexpenseType) {
    filteredData = filteredData.filter((item) => item.expensesType === selectedexpenseType);
  }

  setFilteredExpensesData(filteredData);
}, [selectedexpenseType, expenseData]); // Runs when these values change







  const handleEditClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleDeleteClick = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${baseUrl}/api/AllExpenses/delete/${id}/${userId}/${oId}`,
          {
            method: "DELETE",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete the record.");
        }

        // Handle response as JSON or plain text
        const contentType = response.headers.get("content-type");
        let message = "The record has been deleted.";
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();
          message = data.message || message;
        } else {
          message = await response.text();
        }

        // Update the local state after successful deletion
        const updatedDriversData = expenseData.filter((row) => row.id !== id);
        setExpenseData(updatedDriversData);
        fetchExpensesData();

        toast.success("The record has been deleted!", {
          position: "top-right",
          autoClose: 1000, // Auto close after 2 seconds
        });
      } catch (error) {
        toast.error("An error occurred!", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    // setSelectedRow(null);
  };

  const handleChangea = (e) => {
    const { name, value } = e.target;
    setSelectedRow((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const patchSave = async () => {
    if (!selectedRow) return;
  
    setLoadingc(true); // Start loading
  
    const formData = new FormData();
    formData.append("name", selectedRow.name);
    formData.append("amount", selectedRow.amount);
    formData.append("paymentType", selectedRow.paymentType);
    formData.append("expensesType", selectedRow.expensesType);
    formData.append("mobileNo", selectedRow.mobileNo);
  
    try {
      const response = await fetch(
        `${baseUrl}/api/AllExpenses/update/${selectedRow.id}/${userId}/${oId}`,
        {
          method: "PATCH",
          body: formData,
        }
      );
  
      if (response.ok) {
        // const updatedDriversData = expenseData.map((row) =>
        //   row.id === selectedRow.id ? selectedRow : row
        // );
  
        // setExpenseData(updatedDriversData);
        fetchExpensesData();
        handleClose();
  
        // Show success toast
        toast.success("Expense updated successfully!", {
          position: "top-right",
          autoClose: 1000, // Close after 2 seconds
         
        });
      } else {
        console.error("Error updating expense:", await response.text());
  
        // Show error toast
        toast.error("Failed to update expense!", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error updating expense:", error);
  
      // Show error toast
      toast.error("Something went wrong!", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setLoadingc(false); // Stop loading
    }
  };
 











  // Open edit dialog with selected row data
  const handleEdit = (expense) => {
    setSelectedExpense(expense);
    setIsEditDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };


  //  type wise filter
  const handleBusChangea = (event) => {
    const expensesType = event.target.value;
    setSelectedBusType(expensesType);

    if (expensesType === "all") {
      setFilteredData(expenseData); // Show all data when "All" is selected
    } else {
      setFilteredData(expenseData.filter((row) => row.expensesType === expensesType));
    }
  };



  // Apply date filtering
  // const applyDateFilter = (
  //   dateFilter,
  //   customStart = null,
  //   customEnd = null,
  //   data = expenseData
  // ) => {
  //   let filtered = data; // Use provided data or full API data

  //   const today = new Date();
  //   const yesterday = new Date(today);
  //   yesterday.setDate(today.getDate() - 1);

  //   const lastWeekStart = new Date(today);
  //   lastWeekStart.setDate(today.getDate() - 7);

  //   const firstDayCurrentMonth = new Date(
  //     today.getFullYear(),
  //     today.getMonth(),
  //     1
  //   );
  //   const firstDayLastMonth = new Date(
  //     today.getFullYear(),
  //     today.getMonth() - 1,
  //     1
  //   );
  //   const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

  //   if (dateFilter === "today") {
  //     filtered = filtered.filter((row) =>
  //       isSameDate(new Date(row.date), today)
  //     );
  //   } else if (dateFilter === "yesterday") {
  //     filtered = filtered.filter((row) =>
  //       isSameDate(new Date(row.date), yesterday)
  //     );
  //   } else if (dateFilter === "lastWeek") {
  //     filtered = filtered.filter(
  //       (row) =>
  //         new Date(row.date) >= lastWeekStart && new Date(row.date) < today
  //     );
  //   } else if (dateFilter === "currentMonth") {
  //     filtered = filtered.filter(
  //       (row) => new Date(row.date) >= firstDayCurrentMonth
  //     );
  //   } else if (dateFilter === "lastMonth") {
  //     filtered = filtered.filter(
  //       (row) =>
  //         new Date(row.date) >= firstDayLastMonth &&
  //         new Date(row.date) <= lastDayLastMonth
  //     );
  //   } else if (dateFilter === "custom" && customStart && customEnd) {
  //     filtered = filtered.filter((row) => {
  //       const rowDate = new Date(row.date);
  //       return rowDate >= customStart && rowDate <= customEnd;
  //     });
  //   }

  //   setFilteredData(filtered);
  // };

  // Helper function to check if two dates are the same
  // const isSameDate = (date1, date2) => {
  //   return (
  //     date1.toISOString().split("T")[0] === date2.toISOString().split("T")[0]
  //   );
  // };

  // Handle custom date apply
  // const handleApplyCustomDate = () => {
  //   if (customStartDate && customEndDate) {
  //     applyDateFilter(
  //       "custom",
  //       new Date(customStartDate),
  //       new Date(customEndDate)
  //     );
  //     setOpenCustomDialog(false);
  //   }
  // };

  // Extract unique types from expenseData
  // const uniqueTypes = [...new Set(expenseData.map((row) => row.expensesType))];
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [formData, setFormData] = useState({
   
   
    name: "",
    mobileNo: "",
    expensesType: "",
    amount: "",
    paymentType:''
  });

  const handleOpenAddDialog = () => setOpenAddDialog(true);

  const handleCloseAddDialog = () => {
    // Reset form and errors before closing the dialog
    setFormData({
     
      name: "",
      amount: "",
      paymentType:'',
      expensesType: "",
      mobileNo: "",
      date: "",
    });
    setErrors({});
    setOpenAddDialog(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let errorMsg = "";

    // Validate when user moves cursor away
    if (name === "name") {
      if (!value.trim()) {
        errorMsg = "Admin Name is required";
      } else if (!/^[a-zA-Z\s]+$/.test(value)) {
        errorMsg = "Only letters and spaces are allowed";
      }
    } else if (name === "amount") {
      if (!value) {
        errorMsg = "Amount is required";
      } else if (value <= 0) {
        errorMsg = "Amount must be greater than zero";
      }
    } else if (name === "paymentType") {
      if (!value) {
        errorMsg = "paymentType is required";
      } 
    } else if (name === "expensesType") {
      if (!value) {
        errorMsg = "Expense Type is required";
      }
    } else if (name === "mobileNo") {
      if (!value) {
        errorMsg = "Mobile No is required";
      } else if (!/^\d{10}$/.test(value)) {
        errorMsg = "Enter a valid 10-digit mobile number";
      }
    } else if (name === "date") {
      if (!value) {
        errorMsg = "Date is required";
      }
    } 

    // Set error only when moving away from the field
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleCloseToast = () => {
    setOpenToast(false);
  };

  const handleSave = async () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Driver Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name = "Only letters and spaces are allowed";
    }

    


    // Validate Amount (required & must be a positive number)
    if (!formData.amount) {
      newErrors.amount = "Amount is required";
    } else if (formData.amount <= 0) {
      newErrors.amount = "Amount must be greater than zero";
    }

    if (!formData.paymentType) {
      newErrors.paymentType = "paymentType is required";
    }

    // Validate Type (ensure selection)
    if (!formData.expensesType) {
      newErrors.expensesType = "Expense Type is required";
    }

    // Validate Driver Mobile (required & must be a 10-digit number)
    if (!formData.mobileNo) {
      newErrors.mobileNo = "Driver Mobile is required";
    } else if (!/^\d{10}$/.test(formData.mobileNo)) {
      newErrors.mobileNo = "Enter a valid 10-digit mobile number";
    }

    // Validate Date (required)
    if (!formData.date) {
      newErrors.date = "Date is required";
    }

    // Set errors
    setErrors(newErrors);

    // Stop submission if there are validation errors
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      setLoadinga(true);
      console.log("Form Data:", formData);

      const formDataObject = new FormData();
      for (const key in formData) {
        formDataObject.append(key, formData[key]);
      }

      const response = await fetch(
        `${baseUrl}/api/AllExpenses/save/${userId}?role=${userRoleName}`,
        {
          method: "POST",
          body: formDataObject,
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log("Data saved successfully:", result);
        fetchExpensesData();
        handleCloseAddDialog();

        // Show success toast
        toast.success("Expense Added successfully!", {
          position: "top-right",
          autoClose: 1000,
        });

        // Reset form and errors after success
        setFormData({
          amount: "",
          paymentType:'',
          expensesType: "",
          mobileNo: "",
          date: "",
        });
        setErrors({});
      } else {
        console.error("Failed to save data:", response.status);

        // Show error toast
        toast.error("Failed to Add Expense!", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error saving data:", error);

      // Show error toast
      toast.error("An error occurred!", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setLoadinga(false);
    }
  };







const exportToExcel = () => {
  const processedData = filteredExpensesData.map(
    ({ date, name, mobileNo, expensesType, amount, paymentType }) => ({
      Date: date,
      Name: name,
      MobileNo: mobileNo,
      ExpensesType: expensesType,
      Amount: Number(amount) || 0,
      PaymentType: paymentType,
    })
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Admission_Expenses_Reports");

  // Define columns
  worksheet.columns = [
    { header: "Payment Date", key: "Date", width: 15 },
    { header: "Admin Name", key: "Name", width: 20 },
    { header: "Mobile No", key: "MobileNo", width: 15 },
    { header: "Expenses Type", key: "ExpensesType", width: 20 },
    { header: "Amount", key: "Amount", width: 15 },
    { header: "Payment Type", key: "PaymentType", width: 15 },
  ];

  // Add data rows
  processedData.forEach((data) => {
    worksheet.addRow(data);
  });

  // Calculate total expenses
  const totalExpense = processedData.reduce((sum, row) => sum + row.Amount, 0);

  // Add summary row
  const summaryRow = worksheet.addRow({
    Date: "",
    Name: "",
    MobileNo: "",
    ExpensesType: "Total Expense",
    Amount: `₹${totalExpense}`,
    PaymentType: "",
  });

  // Style the summary row
  summaryRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFACD" }, // Light yellow
    };
  });

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light blue
    };
  });

  // Export file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Admission_Expenses_Reports.xlsx";
    link.click();
  });

  handleExportClose();
};



// Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(`Admission Department Expenses List`, 10, 8);

  // Generated On
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // Headers
  const headers = [
    "S.No",
    "Date",
    "Name",
    "Mobile No",
    "Expenses Type",
    "Amount",
    "Payment Type",
  ];

  // Total sum calculation
  let totalAmount = 0;

  // Body rows
  const body = filteredExpensesData.map((row, index) => {
    const amount = Number(row.amount) || 0;
    totalAmount += amount;

    return [
      index + 1,
      row.date,
      row.name,
      row.mobileNo,
      row.expensesType,
      {
        content: `Rs. ${amount}`,
        styles: {
          fontStyle: "bold",
          textColor: [0, 102, 204], // blue
        },
      },
      row.paymentType,
    ];
  });

  // Add summary total row
  body.push([
    {
      content: "Total Amount",
      colSpan: 5,
      styles: {
        halign: "center",
        fontStyle: "bold",
        fillColor: [255, 250, 205], // light yellow
      },
    },
    {
      content: `Rs. ${totalAmount}`,
      styles: {
        fontStyle: "bold",
        fillColor: [255, 250, 205],
        textColor: [0, 0, 0],
      },
    },
    "", // empty cell for payment type
  ]);

  // Generate table
  doc.autoTable({
    startY: 20,
    head: [headers],
    body,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
      fontSize: 9,
    },
    headStyles: {
      fillColor: [63, 81, 181], // Indigo
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // Save file
  doc.save(`Admission_Expenses_Reports.pdf`);
  handleExportClose();
};




const exportToJSON = () => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(filteredData, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `Admission_Expenses_Reports.json`;
  link.click();
  handleExportClose();
};







  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "0px 10px 10px 10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent
        style={{
          Width: "950px",
          margin: "auto",
        }}
      >
        {/* Title Section */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid
  item
  xs={12}
  sx={{
    display: "flex",
    alignItems: "center",
    gap: -1, // optional spacing between icon and text
    paddingBottom: 2,
  }}
>
  <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
    <KeyboardBackspaceIcon fontSize="medium" />
  </IconButton>

  <Typography
    variant="h5"
    sx={{ fontWeight: "bold", color: "#333" }}
  >
    Admission Expenses Reports
  </Typography>
</Grid>

        </Grid>
        {/* Search and Add New Button Section */}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Grid
            container
            spacing={1}
            alignItems="center"
            gap="10px"
            style={{ marginTop: "1px" }}
          >
             {/* Select Date */}
             <Grid item xs={2.5}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="date-select-label">Select DateRange</InputLabel>
                  <Select
                    value={selectedDate}
                    onChange={handleDateChange}
                    label="Select DateRange"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="yesterday">Yesterday</MenuItem>
                    <MenuItem value="lastWeek">Last Week</MenuItem>
                    <MenuItem value="currentMonth">Current Month</MenuItem>
                    <MenuItem value="customDate">Custom Date</MenuItem>
                  </Select>
                </FormControl>
              </Grid>


            {/* Dropdown for Select Type */}
              <Grid item >
                <FormControl style={{ width: "160px" }} variant="outlined" size="small">
                    <InputLabel id="expense-type-label" style={{ fontSize: "12px" }}>
                      Select Type
                    </InputLabel>
                    <Select
                      labelId="expense-type-label"
                      value={selectedexpenseType}
                      onChange={(e) => setSelectedexpenseType(e.target.value)}
                      label="Select Type"
                      style={{ height: "35px", fontSize: "13px" }}
                    >
                      {uniqueExpensesType.map((type, index) => (
                        <MenuItem key={index} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
              </Grid>

               {(role === "TRANSPORT" || role === "PRINCIPAL" || role === "ORGANIZATION") && (
                <FormControl fullWidth style={{ width: "180px", marginLeft: "5px" }} size="small">
                  <InputLabel>Select Admission Admin</InputLabel>
                  <Select
                    value={selectedUsers}
                    onChange={(e) => setSelectedUsers(e.target.value)}
                    label="Select Admission Admin"
                  >
                    {users.map((user) => (
                      <MenuItem key={user.userId} value={user.userId}>
                        {user.userId} - {user.firstName} {user.lastName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

             
            
          </Grid>

          <Grid item xs={3} style={{ display: "flex", justifyContent: "flex-end" ,marginRight:'10px'}}>
  <Button 
    variant="contained" 
    onClick={handleExportClick}  
    style={{ backgroundColor: '#3C3972', fontWeight: 'bold',height:'40px' }}
    startIcon={<PresentToAllIcon />} 
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    {/* <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem> */}
  </Menu>
</Grid>

          {/* <div>
            <Button
              variant="contained"
              onClick={handleOpenAddDialog}
              style={{
                backgroundColor: "#3C3972",
                color: "#fff",
                height: "40px",
                width: "140px",
                fontWeight:'bold'
              }}
            >
              Add New Expense
            </Button>
          </div> */}
        </div>

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                 Payment Date
                </TableCell>
                

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                  Admin Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                 Mobile
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                  Expenses Type
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                  Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                  Payment Type
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    backgroundColor: "#fff9c4",
                    textAlign: "center",
                    fontWeight:"bold",
                      fontSize:'14px'
                  }}
                >
                  Action
                </TableCell> */}
                
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                          <Box display="flex" flexDirection="column" alignItems="center">
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Data...
                                            </Typography>
                                          </Box>
                                        </TableCell>
                </TableRow>
              ) : filteredExpensesData.length === 0 ? ( // Apply filtering here
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredExpensesData.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "40px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.date}
                    </TableCell>

                    

                   

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.name}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.mobileNo}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.expensesType}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      ₹{row.amount}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.paymentType}
                    </TableCell>

                    {/* <TableCell sx={{ textAlign: "center", padding: "2px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "4px",
                          border:"1px solid #ddd",
                          margin:'2px',
                          padding:'2px'
                        }}
                      >
                        <Button
                          sx={{
                            backgroundColor: "#1565c0",
                            color: "white",
                            "&:hover": { backgroundColor: "#0d47a1" },
                            // borderRadius: 2,
                            padding: "2px 4px",
                          }}
                          onClick={() => handleEditClick(row)}
                        >
                          Edit
                        </Button>

                        <Button
                          sx={{
                            backgroundColor: "#a82814",
                            color: "white",
                            "&:hover": { backgroundColor: "#7a1b0e" },
                            // borderRadius: 2,
                            padding: "4px 6px",
                          }}
                          onClick={() => handleDeleteClick(row.id)}
                        >
                          Delete
                        </Button>
                      </Box>
                    </TableCell> */}
                    
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

{/* AddNew post Dialog code */}
        <Dialog open={openAddDialog} onClose={handleCloseAddDialog}>
              <DialogTitle>
                <strong>Add New Expenses</strong>
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  

                  

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Select Date"
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      variant="outlined"
                      autoComplete="off"
                      InputLabelProps={{ shrink: true }}
                      error={!!errors.date}
                      helperText={errors.date}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Admin Name"
                      name="name"
                      value={formData.name}
                      variant="outlined"
                      error={!!errors.name}
                      helperText={errors.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Mobile No"
                      name="mobileNo"
                      value={formData.mobileNo}
                      onChange={handleChange}
                      variant="outlined"
                      type="number"
                      error={!!errors.mobileNo}
                      helperText={errors.mobileNo}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Expenses Type"
                      name="expensesType"
                      value={formData.expensesType}
                      onChange={handleChange}
                      variant="outlined"
                      type="text"
                      error={!!errors.expensesType}
                      helperText={errors.expensesType}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  {/* <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Select Expense Type</InputLabel>

                      <Select
                        fullWidth
                        label="Select Expense Type"
                        name="expensesType"
                        value={formData.expensesType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!errors.expensesType}
                      >
                        <MenuItem value="petrol">Petrol</MenuItem>
                        <MenuItem value="service">Service</MenuItem>
                        <MenuItem value="maintenance">Maintenance</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                      </Select>
                      {errors.expensesType && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {errors.expensesType}
                        </p>
                      )}
                    </FormControl>
                  </Grid> */}

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Amount"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      variant="outlined"
                      type="number"
                      error={!!errors.amount}
                      helperText={errors.amount}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  
                  <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Select Payment Type</InputLabel>

                      <Select
                        fullWidth
                        label="Select Payment Type"
                        name="paymentType"
                        value={formData.paymentType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!errors.paymentType}
                      >
                        <MenuItem value="Cash">Cash</MenuItem>
                        <MenuItem value="Online">Online</MenuItem>
                        <MenuItem value="Credit/DebitCard">Credit/Debit Card</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      {errors.paymentType && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {errors.paymentType}
                        </p>
                      )}
                    </FormControl>
                  </Grid>




                </Grid>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={handleCloseAddDialog}
                  color="primary"
                  variant="outlined"
                >
                  Cancel
                </Button>

                <>
                  <Button
                    onClick={handleSave}
                    // color="success"
                    variant="contained"
                    disabled={loadinga}
                    sx={{
                      backgroundColor: "#3C3972",
                      "&:hover": {
                        backgroundColor: "#3C3972", // Darker blue on hover
                      },
                    }}
                  >
                    {loadinga ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Save"
                    )}
                  </Button>

                  {/* Toast Notification */}
                  <Snackbar
                    open={openToast}
                    autoHideDuration={1000} // Automatically hides after 2s
                    onClose={handleCloseToast}
                    message="Data saved successfully"
                  />
                </>
              </DialogActions>
            </Dialog>




        {/* table edit options */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>
            <strong>Edit Details</strong>
          </DialogTitle>

          <DialogContent>
            {selectedRow && (
              <Grid container spacing={2} sx={{ mt: 1 }}>
                
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Driver Name"
                    name="name"
                    value={selectedRow.name}
                    onChange={handleChange}
                    variant="outlined"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Driver Mobile"
                    name="mobileNo"
                    value={selectedRow.mobileNo}
                    onChange={handleChange}
                    variant="outlined"
                    type="number"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Type"
                    name="expensesType"
                    value={selectedRow.expensesType}
                    onChange={handleChangea}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Amount"
                    name="amount"
                    value={selectedRow.amount}
                    onChange={handleChangea}
                    variant="outlined"
                    type="number"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Payment Type"
                    name="paymentType"
                    value={selectedRow.paymentType}
                    onChange={handleChangea}
                    variant="outlined"
                    type="text"
                  />
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant="outlined">
              Close
            </Button>

            <Button
              onClick={patchSave}
              variant="contained"
              disabled={loadingc}
              sx={{
                backgroundColor: "#3C3972",
                "&:hover": {
                  backgroundColor: "#3C3972", // Darker blue on hover
                },
              }}
            >
              {loadingc ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Save"
              )}
            </Button>
          </DialogActions>
        </Dialog>

        <ToastContainer />

        <>
          {/* Custom Date Dialog */}
          {/* <Dialog
            open={openCustomDialog}
            onClose={() => setOpenCustomDialog(false)}
          >
            <DialogTitle>Select Custom Date Range</DialogTitle>
            <DialogContent>
              <TextField
                label="From Date"
                type="date"
                value={customStartDate}
                onChange={(e) => setCustomStartDate(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                sx={{ my: 1 }}
              />
              <TextField
                label="To Date"
                type="date"
                value={customEndDate}
                onChange={(e) => setCustomEndDate(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                sx={{ my: 1 }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setOpenCustomDialog(false)}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                // onClick={handleApplyCustomDate}
                color="secondary"
                variant="contained"
                sx={{
                  backgroundColor: "#3C3972",
                  "&:hover": {
                    backgroundColor: "#3C3972", // Darker blue on hover
                  },
                }}
              >
                Apply
              </Button>
            </DialogActions>
          </Dialog> */}








 {/* Dialog for start date and end date selection  */}

 <Dialog open={openCustomDialog} onClose={() => setOpenCustomDialog(false)}>
  <DialogTitle sx={{fontWeight:'bold',fontSize:'15px'}}>Select Custom Date Range</DialogTitle>
  <DialogContent>
    <div style={{ display: "flex", gap: "16px" ,marginTop:'10px'}}>
      <TextField
        label="Start Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        fullWidth
      />
      <TextField
        label="End Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        fullWidth
      />
    </div>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenCustomDialog(false)} variant="outlined" sx={{width:'5px'}}>Cancel</Button>
    <Button
      onClick={() => {
        if (startDate && endDate) {
          handleGetButtonClick();
        } else {
          alert("Please select both Start Date and End Date.");
        }
      }}
    sx={{backgroundColor: "#3C3972",color: "#fff", "&:hover": { backgroundColor: "#3C3972" }}}
      variant="outlined"
    >
      Apply
    </Button>
  </DialogActions>
</Dialog>








        </>
      </CardContent>
    </Card>
  );
}

export default AdmissionExpensesReports;